'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blockies = require('blockies');

var _blockies2 = _interopRequireDefault(_blockies);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _web3Utils = require('web3-utils');

var _web3Utils2 = _interopRequireDefault(_web3Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddressImage = function AddressImage(_ref) {
  var address = _ref.address,
      className = _ref.className;

  if (_web3Utils2.default.isAddress(address)) {
    var image = new _blockies2.default({ seed: address.toLowerCase(), size: 8, scale: 16 });
    var classes = className || 'address-image';
    return _react2.default.createElement('span', { style: { backgroundImage: 'url(' + image.toDataURL() + ')' }, className: classes });
  }
  return null;
};

AddressImage.defaultProps = {
  className: ''
};

AddressImage.propTypes = {
  address: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

AddressImage.displayName = 'AddressImage';

exports.default = AddressImage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/AddressImage.js
// module id = 144
// module chunks = 0